/**
 * @generated SignedSource<<b677a023f5c8e1548f7e792d5fd04abc>>
 * @relayHash a7f6b6fc85c04ae7dafc1395f3dccc1b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a7f6b6fc85c04ae7dafc1395f3dccc1b

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteAttestationGuardianInput = {
  id: string;
};
export type useDeDeleteLegalGuardianAttestationMutation$variables = {
  input: De_deleteAttestationGuardianInput;
};
export type useDeDeleteLegalGuardianAttestationMutation$data = {
  readonly de_deleteAttestationGuardian: {
    readonly de_AttestationGuardian: {
      readonly id: string;
    } | null;
  };
};
export type useDeDeleteLegalGuardianAttestationMutation = {
  response: useDeDeleteLegalGuardianAttestationMutation$data;
  variables: useDeDeleteLegalGuardianAttestationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeDeleteLegalGuardianAttestationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_deleteAttestationGuardianPayload",
        "kind": "LinkedField",
        "name": "de_deleteAttestationGuardian",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_AttestationGuardian",
            "kind": "LinkedField",
            "name": "de_AttestationGuardian",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeDeleteLegalGuardianAttestationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_deleteAttestationGuardianPayload",
        "kind": "LinkedField",
        "name": "de_deleteAttestationGuardian",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_AttestationGuardian",
            "kind": "LinkedField",
            "name": "de_AttestationGuardian",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a7f6b6fc85c04ae7dafc1395f3dccc1b",
    "metadata": {},
    "name": "useDeDeleteLegalGuardianAttestationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7f445ba85c4e15276055818120ce60a3";

export default node;
